import { getLANG } from '@/utils';
import { cloneDeep, isEmpty } from 'lodash';

const LANG = getLANG();

const cloudProductConfig = {
  pid: 572,
  cid: 3197,
  cids: [3197, 3198, 3199, 3351, 3352, 3353, 3354],
  commodity: {},
  urlKey: 'insta360plus',
  desc: '云服务',
  enabled: true,
  productPage: {
    productName: LANG['bindServices.productPage.cloud_productName'],
    cName: LANG['bindServices.productPage.cloud_cName_free'],
    itemDesc: LANG['bindServices.productPage.cloud_desc_free'],
    itemNoNeedBtn: LANG['bindServices.productPage.noNeedBtnCloud'],
    thumb: 'https://res.insta360.com/static/8f8e727b4e58d4ddeb5df03f32a31789/page.png',
  },
  thumb: 'https://res.insta360.com/static/8f8e727b4e58d4ddeb5df03f32a31789/page.png',
  /** 显示在产品页的id */
  relatedProductIds: [26, 19],
  learnMoreModal: {
    title: LANG['bindServices.learnMoreModal.cloud_title_free'],
    desc: LANG['bindServices.learnMoreModal.cloud_desc'],
    link: LANG['bindServices.learnMoreModal.cloud_learn_more_link'],
    pointList: [
      {
        imgUrl: 'https://res.insta360.com/static/051bb29cdf392a9ac31c6b6ac42246af/Frame%201973770996.png',
        title: LANG['bindServices.learnMoreModal.cloud_point_1_title'],
        desc: LANG['bindServices.learnMoreModal.cloud_point_1_desc_free'],
      },
      {
        imgUrl: 'https://res.insta360.com/static/f4967da5512b64b851fa2d2b52e3730f/Frame%201973770998.png',
        title: LANG['bindServices.learnMoreModal.cloud_point_2_title'],
        desc: LANG['bindServices.learnMoreModal.cloud_point_2_desc'],
      },
      {
        imgUrl: 'https://res.insta360.com/static/7b8b35661da83cb9ae5ef2dc5fb21a9e/Frame%201973770997.png',
        title: LANG['bindServices.learnMoreModal.cloud_point_3_title'],
        desc: LANG['bindServices.learnMoreModal.cloud_point_3_desc'],
      },
    ],
  },
  extraType: 'cloud_services',
};

export default cloudProductConfig;

export function setCommodityToCloudConfig(commodities) {
  if (isEmpty(commodities)) return;
  if (Array.isArray(commodities)) {
    const _commodity = commodities.filter((c) => c.id === cloudProductConfig.cid)[0];
    const commodity = _commodity ? cloneDeep(_commodity) : null;
    cloudProductConfig.commodity = commodity;
  } else {
    cloudProductConfig.commodity = commodities;
  }
}

export const cloudCid = cloudProductConfig.cid;
export const cloudCids = cloudProductConfig.cids;
export function getCloudCid() {
  return cloudProductConfig.cid;
}

export const cloudPid = cloudProductConfig.pid;
export function getCloudPid() {
  return cloudProductConfig.pid;
}

export const getCloudProductConfig = () => {
  return cloudProductConfig;
};

const isItemCloudProduct = (item) => {
  return [item.product, item.productId, item.pid].includes(cloudPid) || cloudCids.includes(item.commodityId || item.id);
};

/**
 * @param {[] | {}} items - commodity[] | {}
 * @desc 当前商品是否是云存储商品或者 是否包含云服务商品
 * 如果没有商品返回undefined
 */
export const hasCloudService = (item) => {
  if (isEmpty(item)) return undefined;

  if (Array.isArray(item)) return item.some((d) => isItemCloudProduct(d));
  return isItemCloudProduct(item);
};

/**
 * @param   {String}
 * @returns {Boolean}
 * @desc    根据国家维度判断是否隐藏云服务权益
 * 针对"产品详情页"CN暂无物料,业务协调年后再单独处理@张琳悦;后续处理时直接删除详情页代码逻辑,该方法保留(其他地方有使用到)
 */
export const hideCloudServiceByCountry = (countryCode) => {
  return ['CN'].includes(countryCode);
};

/**
 * @description 部分地区云存权益不一样，目前只有中美
 *
 */
export const diffCloudBenifitCountry = () => {
  return ['CN', 'US'];
};
